import styled from 'styled-components'

interface MapContainerProps {
  $height?: string
  $accentColor?: string
}

export const MapWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 6px;
`

export const MapContainer = styled.div<MapContainerProps>`
  --map-marker-color: ${({ $accentColor }) => $accentColor || '#00ADE6'};
  width: 100%;
  height: ${({ $height }) => $height || '240px'};
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e0e0e0;

  @media print {
    height: 250px;
    page-break-inside: avoid;
    break-inside: avoid;
  }
`

export const MapPlaceholder = styled.div<{ $height?: string }>`
  width: 100%;
  height: ${({ $height }) => $height || '240px'};
  background: #f5f5f5;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-family: system-ui, sans-serif;

  @media print {
    display: none;
  }
`

// Styles for numbered markers - injected via document.head
// NOT styled-components to ensure proper Mapbox marker styling
export const markerStyles = `
  .pdf-export-marker {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: var(--map-marker-color, #00ADE6);
    color: white;
    font-weight: 600;
    font-size: 12px;
    font-family: system-ui, -apple-system, sans-serif;
    border: 2px solid white;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    cursor: pointer;
    transition: transform 0.2s ease;
  }

  .pdf-export-marker:hover {
    transform: scale(1.15);
    z-index: 10;
  }

  .pdf-export-marker.subject {
    background: var(--map-marker-color, #00ADE6);
    width: 32px;
    height: 32px;
    font-size: 14px;
  }

  .pdf-export-marker.subject svg {
    width: 16px;
    height: 16px;
    stroke: white;
  }

  .pdf-export-popup .mapboxgl-popup-content {
    padding: 8px 12px;
    border-radius: 6px;
    font-family: system-ui, -apple-system, sans-serif;
    font-size: 12px;
    max-width: 200px;
  }

  .pdf-export-popup .mapboxgl-popup-close-button {
    display: none;
  }
`
